import { BackupEmpresaService } from 'src/app/services/backup-empresa.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BackendApiService } from 'src/app/services/backend-api.service';
import { Pessoa } from 'src/app/model/pessoa';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-section-diretoria-executiva',
  templateUrl: './section-diretoria-executiva.component.html',
  styleUrls: ['./section-diretoria-executiva.component.scss'],
})
export class SectionDiretoriaExecutiva implements OnInit, OnDestroy {
  diretoria = new Array();
  url_base = environment.backend.base_url;
  subsctiption: Array<Subscription> = []


  constructor(private backendApiService: BackendApiService, public backup: BackupEmpresaService) {}
  ngOnDestroy(): void {
    this.subsctiption.forEach((res) => res.unsubscribe)
  }

  finddiretoria(){
    let sub = this.backendApiService.findAllDiretoria().subscribe({
      next: (res) => {
        this.diretoria = res.filter((res: Pessoa) => res)
      },
      error: (err) => {
        this.diretoria = this.backup.diretoriaExecutiva()
      }
    })
  this.subsctiption.push(sub)
  }

  ngOnInit(): void {
    this.finddiretoria()
  }
}
